import BeamboxInit from '@core/app/actions/beambox/beambox-init';

export default BeamboxInit;
